import { groupLifeService } from '@/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

const POLL_INTERVAL_MS = 2_000;

export const GROUP_LIFE_RERATE_FAILURE_MESSAGE =
  'Serviço do InsureMO instável para recálculo, tente novamente em alguns segundos';

export function useMembersRatingProgress(params: {
  policyId: string | null;
  enabled: boolean;
}) {
  const query = useQuery({
    queryKey: ['group-life', 'members-rating-progress', params.policyId],
    queryFn: async () => {
      if (!params.policyId) return null;
      const res = await groupLifeService.getMembersRatingProgress(
        params.policyId
      );
      if (!res.success || !res.data) {
        throw new Error(
          res.error ?? 'Falha ao consultar o progresso da re-tarifação'
        );
      }
      return res.data;
    },
    enabled: params.enabled && !!params.policyId,
    refetchInterval: query => {
      if (!params.enabled) return false;
      if (query.state.data?.status === 'failed') return false;
      return POLL_INTERVAL_MS;
    },
    staleTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  const progress = useMemo(() => {
    const total = query.data?.total ?? 0;
    const rated = query.data?.rated ?? 0;
    const pending = query.data?.pending ?? Math.max(0, total - rated);
    const percent =
      total > 0 ? Math.min(100, Math.round((rated / total) * 100)) : 0;
    return { total, rated, pending, percent };
  }, [query.data]);

  const error =
    query.data?.status === 'failed'
      ? GROUP_LIFE_RERATE_FAILURE_MESSAGE
      : undefined;

  return { progress, isLoading: query.isLoading, error };
}
